import React from "react";
import { Navigate } from "react-router-dom";

import AppearanceCommon from "@/features/settings/AppearanceCommon.jsx";
import RouteFallback from "@/sot/primitives/RouteFallback.jsx";
import { updatePharmacyMemberThemePreference } from "@/services/pharmacyMemberAccountService.js";
import { usePracticeTeamAccess } from "./practiceTeamMemberAccess.js";
import PracticeTeamWorkspaceHeader from "./PracticeTeamWorkspaceHeader.jsx";

function safeText(value) {
  return String(value || "").trim();
}

export default function PracticeTeamAppearance() {
  const { auth, invite, resolving, allowed } = usePracticeTeamAccess();
  const userId = safeText(auth?.user?.id);

  if (resolving) {
    return <RouteFallback label="Loading Practice Team..." />;
  }

  if (!allowed) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="min-h-dvh bg-[rgb(var(--afrimed-shell-background))] text-[rgb(var(--clr-on-surface))]">
      <PracticeTeamWorkspaceHeader section="account" invite={invite} />
      <AppearanceCommon
        role="pharmacy"
        backTo="/practice-team/account"
        onPersistTheme={
          userId
            ? async (nextTheme) => {
                await updatePharmacyMemberThemePreference({
                  userId,
                  themePreference: nextTheme,
                });
              }
            : undefined
        }
      />
    </div>
  );
}
